import { createSlice, PayloadAction } from "redux-starter-kit";

export interface DisplayHelpPanel {
  header: string;
  contentType: "permissions" | "teamDetails" | "test" | "inheritedAccess";
  footer?: string;
  widenContent: boolean;
  customContent?: string;
}

export interface HelpPanelState {
  displayHelpPanel: DisplayHelpPanel | undefined;
  helpPanelOpenState: boolean | undefined;
}

const initialState: HelpPanelState = {
  displayHelpPanel: undefined,
  helpPanelOpenState: false,
};

const slice = createSlice({
  initialState,
  slice: "helpPanel",
  reducers: {
    setHelpPanelContent: (
      state: HelpPanelState,
      action: PayloadAction<DisplayHelpPanel | undefined, string>
    ) => {
      state.displayHelpPanel = action.payload;
    },
    setHelpPanelOpenState: (
      state: HelpPanelState,
      action: PayloadAction<boolean | undefined>
    ) => {
      state.helpPanelOpenState = action.payload;
    },
  },
});

const { actions, reducer } = slice;

export default slice;
export { actions, reducer };
